import { Avatar as MuiAvatar, AvatarProps, styled, Typography } from '@mui/material';
import { FC } from 'react';

type Props = {
  initials?: string;
} & AvatarProps;

const StyledMuiAvatar = styled(MuiAvatar)(({ theme, sizes }) => ({
  height: sizes,
  width: sizes,
  backgroundColor: theme.palette.grey['50'],
  borderRadius: '8px'
}));

export const Avatar: FC<Props> = ({ initials, ...avatarProps }) => {
  return (
    <StyledMuiAvatar variant="rounded" sizes={avatarProps.sizes || '36px'} {...avatarProps}>
      {initials && (
        <Typography color={'primary'} fontFamily="Rubik">
          {initials}
        </Typography>
      )}
    </StyledMuiAvatar>
  );
};
